import * as api from 'Shared/api';
import {
  updateNotificationsSettings,
  updateSuggestedTopics,
  skipStartGuideSection,
  hideSuggestMember,
  updateSeenDiscussionRoom,
  updateSeenZoomAnnouncementBanner,
  updateShowNotificationSettingsCard,
  generateAccessToken,
  accessToken,
} from 'Shared/api/user';
import { getAsanaData } from 'Shared/api/asana';
import * as JiraApi from 'Shared/api/Jira.api';
import { handleError, showNotificationError } from 'Shared/helpers';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

export const updatePulse =
  ({ user, showPulsePrompt, pulseMood }) =>
  dispatch =>
    api.updatePulse({ user, showPulsePrompt, pulseMood }).then(
      response =>
        dispatch({
          type: 'UPDATE_PULSE_RESPONSE',
          payload: response.data,
        }),
      error => {
        dispatch(handleError(error));
      }
    );

export const updateProfile =
  (user, options = {}) =>
  dispatch =>
    api.updateProfile(user).then(
      response => {
        if (!options.supressSuccessMessage) {
          WpToastManager.success('Success!');
        }
        dispatch({
          type: 'UPDATE_PROFILE_RESPONSE',
          payload: response.data,
        });
        return response;
      },
      error => {
        dispatch(handleError(error));
      }
    );

export const getSyncStatus = () => dispatch => {
  dispatch({ type: 'SYNC_GET_REQUEST' });

  return api.getSyncStatus().then(
    resp => {
      dispatch({
        type: 'SYNC_GET_RESPONSE',
        payload: resp.data,
      });
    },
    () => null
  );
};

export const getRecurringMeetings = queryParams => dispatch =>
  api
    .getRecurringMeetings(queryParams)
    .then(resp =>
      dispatch({
        type: 'GET_RECURRING_MEETINGS_RESPONSE',
        payload: resp.data,
      })
    )
    .catch(error => dispatch(handleError(error)));

export const disconnectDataSource = id => dispatch =>
  api.disonnectdataSource(id).then(
    () => {
      dispatch({
        type: 'USER_DISCONNECT_DATA_SOURCE',
        payload: id,
      });
      WpToastManager.success('Success!');
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const getManagerAssistantSettings = () => dispatch =>
  api.getManagerAssistantSettings().then(
    response => {
      dispatch({
        type: 'MANAGER_ASSISTANT_SETTINGS_GET_RESPONSE',
        payload: response.data,
      });
      return response;
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const updateManagerAssistantSetting = (id, params) => dispatch =>
  api.updateManagerAssistantSetting(id, params).then(
    response => {
      dispatch({
        type: 'MANAGER_ASSISTANT_SETTING_PUT_RESPONSE',
        payload: response.data,
      });
      WpToastManager.success('Success!');
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const updateNotificationsSettingsAction = notificationsSettings => async (dispatch, getState) => {
  const currentNotificationsSettings = getState().user.notificationsSettings;
  dispatch({ type: 'UPDATE_NOTIFICATIONS_SETTINGS_REQUEST', payload: { notificationsSettings } });
  try {
    const response = await updateNotificationsSettings(notificationsSettings);
    return response;
  } catch (e) {
    WpToastManager.danger(e);
    dispatch({
      type: 'UPDATE_NOTIFICATIONS_SETTINGS_ERROR',
      payload: { notificationsSettings: currentNotificationsSettings },
    });
    return e;
  }
};

export const updateSuggestedTopicsAction = suggestedTopics => async (dispatch, getState) => {
  const currentSuggestedTopics = getState().user.suggestedTopics;
  dispatch({ type: 'UPDATE_SUGGESTED_TOPICS_REQUEST', payload: { suggestedTopics } });
  const suggestedTopicsParams = suggestedTopics.map(({ text }) => text);
  try {
    const response = await updateSuggestedTopics({ suggestedTopics: suggestedTopicsParams });
    return response;
  } catch (e) {
    WpToastManager.danger(e);
    dispatch({
      type: 'UPDATE_SUGGESTED_TOPICS_ERROR',
      payload: { suggestedTopics: currentSuggestedTopics },
    });
    return e;
  }
};

export const skipStartGuideSectionAction = section => async dispatch => {
  dispatch({ type: 'SKIP_START_GUIDE_SECTION_REQUEST', payload: { section } });
  try {
    await skipStartGuideSection(section);
  } catch (e) {
    dispatch({ type: 'SKIP_START_GUIDE_SECTION_ERROR', payload: { section } });
    showNotificationError(e);
  }
};

export const hideSuggestMemberAction =
  ({ id }) =>
  async dispatch => {
    try {
      const response = await hideSuggestMember(id);
      dispatch({ type: 'HIDE_SUGGEST_MEMBER_RESPONSE', payload: { id } });
      return response;
    } catch (e) {
      showNotificationError(e);
      return e;
    }
  };

export const loadAsanaData = () => async dispatch => {
  try {
    const response = await getAsanaData();
    dispatch({ type: 'LOAD_ASANA_DATA_RESPONSE', payload: response.data.asanaData });
    return response;
  } catch (e) {
    showNotificationError(e);
    return e;
  }
};

export const createAccessToken = () => async dispatch => {
  try {
    const response = await generateAccessToken();
    dispatch({ type: 'GENERATE_API_TOKEN', payload: response.data });
    return response;
  } catch (e) {
    showNotificationError(e);
    return e;
  }
};

export const getAccessToken = () => async dispatch => {
  try {
    const response = await accessToken();
    dispatch({ type: 'GET_ACCESS_TOKEN', payload: response.data });
    return response;
  } catch (e) {
    showNotificationError(e);
    return e;
  }
};

export const loadJiraData = () => async dispatch => {
  try {
    const response = await JiraApi.getJiraData();
    dispatch({ type: 'LOAD_JIRA_DATA_RESPONSE', payload: response.data.jiraData });
    return response;
  } catch (e) {
    showNotificationError(e);
    return e;
  }
};

export const updateZoomContextAction = zoomContext => dispatch =>
  dispatch({ type: 'UPDATE_ZOOM_CONTEXT', payload: zoomContext });

export const updateSeenDiscussionRoomAction = () => dispatch =>
  updateSeenDiscussionRoom().then(() => dispatch({ type: 'UPDATE_SEEN_DISCUSSION_ROOM_SUCCESS' }));

export const updateSeenZoomAnnouncementBannerAction = () => dispatch =>
  updateSeenZoomAnnouncementBanner().then(() => dispatch({ type: 'UPDATE_SEEN_ZOOM_ANNOUNCEMENT_BANNER_SUCCESS' }));

export const updateShowNotificationSettingsCardAction = value => dispatch => {
  dispatch({ type: 'UPDATE_SHOW_NOTIFICATION_SETTINGS_CARD', payload: value });
  updateShowNotificationSettingsCard();
};
